import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { dataDefault } from 'Components/User/Batches/BulkoBag'
import { apiBatchesList, apiBatchesView } from 'Services/UserService'

export const getData = createAsyncThunk('user/batches/getData', async datas => {
    const { data } = await apiBatchesList(datas)
    return data
})

export const getView = createAsyncThunk('user/batches/getView', async id => {
    if (!id) return viewData
    const { data } = await apiBatchesView(id)
    data.batch_bulko_bag = data.batch_bulko_bag && data.batch_bulko_bag.length !== 0 ? data.batch_bulko_bag : [dataDefault]
    return data
})

const viewData = {
    name: '',
    batch_bulko_bag: [dataDefault],
}

export const batchesSlice = createSlice({
    name: 'user/batches',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            tabs: 0,
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setTabs: (state, { payload }) => {
            state.table.tabs = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setTabs } = batchesSlice.actions

export default batchesSlice.reducer
